<template>
  <div>
    <div class="tab-wrapper">
      <el-tabs v-model="activeName" :stretch="true" type="card">
        <el-tab-pane v-for="item in tabLabel" :key="item.name" :name="item.name">
          <span slot="label">{{ item.label }}</span>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--订单概要 -->
    <OrderSummary v-if="activeName === 'orderSummary'" />
    <!--订单明细-->
    <OrderDetail v-if="activeName === 'orderDetail'" />
  </div>
</template>

<script>
import OrderSummary from './orderSummary';
import OrderDetail from './orderDetail';

export default {
  name: 'Index',
  components: { OrderSummary, OrderDetail },
  data() {
    return {
      tabLabel: [
        { label: '订单概要', name: 'orderSummary' },
        { label: '订单明细', name: 'orderDetail' },
      ],
      activeName: 'orderSummary',
    };
  },
  methods: {
    handleActiveName(val) {
      console.log(val, 'sssssssssssssssssssssss');
    },
  },
};
</script>

<style scoped lang="scss">
.tab-wrapper {
  background: #fff;
}
::v-deep .el-tabs {
  .el-tabs__nav {
    border: 0;
    .el-tabs__item {
      flex: none;
      width: 170px;
      border-right: 1px solid #e4e7ed;
      /* &.is-active {
        border-left: 0;
      } */
      &:first-child {
        border-right: 0;
      }
    }
  }
}
</style>
